import { useMemo } from 'react';

import { generateThemeBranding } from '../../common/utils/generate-theme-branding';
import type { BrandingTheme, CSMTheme } from '../../types';

/**
 * Hook to access theme styles based on configuration
 * @param themeConfig - Custom theme configuration or undefined to use default
 * @returns ThemeStyles - Always returns valid theme styles
 */
export const useGenerateThemeBranding = (themeConfig: BrandingTheme): CSMTheme => {
	return useMemo(() => {
		const theme = generateThemeBranding(themeConfig);

		return theme;
	}, [themeConfig]);
};
